import { Size } from '@/hooks/useServerEnv';
import { normalisation } from '@utilities/vector';

export const getProfileDx = (
  x: number,
  labelRight: boolean,
  container: SVGSVGElement | null
) => {
  if (labelRight) {
    return `${x * 100}%`;
  }
  if (container !== null) {
    const titleWidth = container.getBBox().width;
    const offset = titleWidth + 16;
    return `calc(${x * 100}% - ${offset}px)`;
  }
};

export const keys = ['Fair Value', 'Share Price'];

export const valuationPaddingBreakPoints = {
  desktop: 43,
  mobile: 41,
};

export const axisPaddingBreakPoints = {
  desktop: 75,
  mobile: 70,
};

export const breakPointMapper = {
  [Size.SM]: 'mobile',
  [Size.LG]: 'desktop',
};

export const bandingKeys = ['20% Undervalued', 'About Right', '20% Overvalued'];
export const bandingKeysReversed = bandingKeys.slice().reverse();

export const normalise = (fairValue, sharePrice) => {
  const normalisedValues = normalisation([fairValue, sharePrice]);
  const normalisedFairValue = normalisedValues[0];
  const normalisedSharePrice = normalisedValues[1];
  return {
    [keys[0]]: normalisedFairValue < 0 ? 0 : normalisedFairValue,
    [keys[1]]: normalisedSharePrice < 0 ? 0 : normalisedSharePrice,
  };
};
